import { useQuery } from "@tanstack/react-query";

import DataSvc from "../../../../services/dataSvc";

interface UseFacilityReviewsProps {
  locationId: string;
  sort?: string;
  order?: string;
  limit?: number;
  offset?: number;
  isReplied?: number;
  seek_total_count?: boolean;
  periodFromDate?: string;
  periodToDate?: string;
}

const useFacilityReviews = ({
  locationId,
  sort = "review_date",
  order = "desc",
  limit = 3,
  offset = 0,
  isReplied,
  seek_total_count = false,
  periodFromDate,
  periodToDate
}: UseFacilityReviewsProps) => {
  const query = useQuery({
    queryKey: [
      "facilityReviews",
      locationId,
      sort,
      order,
      limit,
      offset,
      isReplied,
      seek_total_count,
      periodFromDate,
      periodToDate
    ],
    queryFn: () => {
      if (!locationId) return { data: [], count: 0 };
      return DataSvc.getFacilityReviews({
        locationId,
        sort,
        order,
        limit,
        offset,
        ...(isReplied !== undefined && { isReplied }),
        ...(seek_total_count && { seek_total_count }),
        ...(periodFromDate && { periodFromDate }),
        ...(periodToDate && { periodToDate })
      });
    },
    enabled: !!locationId
  });

  const responseData = query.data;
  const reviews = responseData?.data || [];
  const count = responseData?.count || 0;

  return {
    reviews,
    count,
    isLoading: query.isLoading,
    refetch: query.refetch
  };
};

export default useFacilityReviews;
